export default __webpack_public_path__ + "static/media/icon1.eb147478.svg";